import React, { useEffect, useState } from 'react';
import {
    Area,
    CartesianGrid,
    Legend,
    AreaChart,
    ResponsiveContainer,
    XAxis,
    YAxis,
    Tooltip,
} from 'recharts';

let moment = require('moment');

const AverageDaysToProcessGraph = ({ analyticData }: any) => {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        let newChartData = [];
        if (analyticData.dateRangeData) {
            for (const [key, value] of Object.entries(
                analyticData.dateRangeData
            )) {
                newChartData.push({
                    fromDate: key,
                    'Average Days to Process': parseFloat(
                        //@ts-ignore
                        value.averageDaysToProcess
                    ).toFixed(2),
                });
            }
            setChartData(
                newChartData.sort((a, b) => {
                    const momentA = moment(a.fromDate, 'MM/YYYY').startOf(
                        'month'
                    );
                    const momentB = moment(b.fromDate, 'MM/YYYY').startOf(
                        'month'
                    );

                    return momentA.isAfter(momentB) ? 1 : -1;
                })
            );
        }
    }, [analyticData]);

    return (
        <ResponsiveContainer width={'50%'} height={250}>
            <AreaChart
                data={chartData}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}>
                <CartesianGrid />
                <XAxis dataKey="fromDate" height={30} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Area
                    type="monotone"
                    dataKey="Average Days to Process"
                    stroke="#1b1e21"
                    fill="#c6c8ca"
                />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default AverageDaysToProcessGraph;
